import React, { useState, useMemo, useEffect } from "react";
import {
    Plus,
    ChevronDown,
    Edit2,
    Trash2,
    Search,
    Layers,
    AlertTriangle,
    X,
} from 'react-feather';
import './Complements.css';
import { all_routes } from '../../../Router/all_routes';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SessionControl from '../../components/SessionControl/sessioncontrol';
import CheckRestauSelected from '../../components/SessionControl/checkrestauselected';
import CatalogueNav from '../../components/CatalogueNav/CatalogueNav';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { base_api_url } from '../../../environment';

/* ================================================================
   VALEURS INITIALES DES FORMS
   ================================================================ */
const Complement_groupe = {
    nom: '',
};

const COMPLEMENT = { 
    nom: '',
    prix: '' 
};

/* ================================================================
   COMPOSANT PRINCIPAL
   ================================================================ */
const Complements = () => {
    const route = all_routes;
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();

    
    // Gestion sécurisée de la devise
    const devise = (() => {
        try {
            const restaurant = JSON.parse(localStorage.getItem("restaurant"));
            return restaurant?.Restaurant?.devise || restaurant?.restaurant?.devise || '€';
        } catch {
            return '€';
        }
    })();

    /* ── State data ─────────────────────────────────────────── */
    const [groupes, setGroupes] = useState([]);
    const [openGroups, setOpenGroups] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [modalGroupe, setModalGroupe] = useState(false);
    const [editingGroupe, setEditingGroupe] = useState(null);
    const [formGroupe, setFormGroupe] = useState(Complement_groupe);
    const [modalItems, setModalItems] = useState(false);
    const [targetGroupeId, setTargetGroupeId] = useState(null);
    const [itemsForms, setItemsForms] = useState([{ ...COMPLEMENT }]);
    const [modalDelete, setModalDelete] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // Gestion sécurisée du token et restoId
    const token = (() => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            return user?.access_token || null;
        } catch {
            return null;
        }
    })();
    
    const ideresto = (() => {
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            return user?.restoId || null;
        } catch {
            return null;
        }
    })();

    /* ── Accordéon ──────────────────────────────────────────── */
    const toggleGroup = (id) =>
        setOpenGroups(prev => ({ ...prev, [id]: !prev[id] }));

    /* ── Recherche ──────────────────────────────────────────── */
    const filteredGroupes = useMemo(() => {
        const t = searchTerm.toLowerCase().trim();

        if (!Array.isArray(groupes)) return [];

        if (!t) return groupes;

        return groupes
            .map(g => ({
                ...g,
                complements: (g.complements || []).filter(c =>
                    c.nom.toLowerCase().includes(t)
                ),
                _matchGroup: g.nom.toLowerCase().includes(t),
            }))
            .filter(g => g._matchGroup || (g.complements && g.complements.length > 0));
    }, [groupes, searchTerm]);

    const fetchGroupeComplements = async () => {
        setLoading(true);
        try {
            if (!token || !ideresto) {
                console.warn("Token ou ID restaurant manquant");
                setGroupes([]);
                return;
            }

            const url = `${base_api_url}cmplt/complement_groups/${ideresto}`;
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            console.log("COMPLEMENTS:", response.data);
            
            let groupeComplementsData = response.data.complement_groups || [];
            setGroupes(groupeComplementsData);

            if (response.status === 200 || response.status === 201) {
                if (groupeComplementsData.length <= 0) {
                    MySwal.fire({
                        icon: "info",
                        text: "Vous n'avez pas encore de groupes de compléments.",
                        toast: true,
                        position: "bottom-end",
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        customClass: {
                            popup: "pixel-toast",
                        },
                    });
                }
            }
        } catch (error) {
            console.error("Erreur lors du chargement des groupes de compléments:", error);

            let errorMessage = "Impossible de charger les groupes de compléments.";

            if (error.response) {
                const status = error.response.status;

                switch (status) {
                    case 401:
                        errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
                        setTimeout(() => {
                            navigate(route.signin);
                        }, 2000);
                        break;

                    case 404:
                        errorMessage = "Aucun groupe de compléments trouvé pour ce restaurant ou le restaurant n'existe pas.";
                        break;

                    case 500:
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
                        break;

                    default:
                        errorMessage = error.response.data?.message || "Une erreur inattendue s'est produite lors du chargement des groupes de compléments.";
                }
            } else if (error.request) {
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
            }

            MySwal.fire({
                icon: "error",
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });

            setGroupes([]);
        } finally {
            setLoading(false);
        }
    };

    // Fonction pour créer un groupe de compléments
    const createComplementGroup = async (nomGroupe) => {
        try {
            setLoading(true);

            if (!nomGroupe || !nomGroupe.trim()) {
                MySwal.fire({
                    icon: "warning",
                    text: "Le nom du groupe est requis.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                });
                return false;
            }

            const groupeData = {
                id_restaurant: ideresto,
                nom: nomGroupe.trim()
            };

            console.log("Création du groupe avec les données :", groupeData);

            const response = await axios.post(
                `${base_api_url}cmplt/complement_group`,
                groupeData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log("Réponse API création groupe :", response.data);

            if (response.status === 201) {
                MySwal.fire({
                    icon: "success",
                    text: "Le groupe de compléments a été créé avec succès.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                });

                await fetchGroupeComplements();
                return true;
            }

            return false;

        } catch (error) {
            console.error("Erreur lors de la création du groupe :", error);

            let errorMessage = "Une erreur est survenue lors de la création du groupe.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 401:
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
                        setTimeout(() => {
                            navigate(route.signin);
                        }, 2000);
                        break;

                    case 404:
                        errorMessage = errorData?.error || "Le restaurant spécifié n'existe pas.";
                        break;

                    case 500:
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer plus tard.";
                        break;

                    default:
                        errorMessage = errorData?.error || errorData?.message || "Une erreur inattendue s'est produite.";
                }
            } else if (error.request) {
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
            }

            MySwal.fire({
                icon: "error",
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 4000,
            });

            return false;

        } finally {
            setLoading(false);
        }
    };

    const handleSaveGroupe = async () => {
        if (!formGroupe.nom.trim()) {
            MySwal.fire({
                icon: "warning",
                text: "Veuillez saisir un nom pour le groupe.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }

        if (editingGroupe) {
            // Modification
            try {
                setLoading(true);

                const response = await axios.put(
                    `${base_api_url}cmplt/complement_group/${editingGroupe.id_complement_group}`,
                    {
                        nom: formGroupe.nom.trim(),
                        statut: 1,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                console.log("Modification du groupe de compléments :", response.data);

                MySwal.fire({
                    icon: "success",
                    text: "Le groupe de compléments a été modifié avec succès.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                });

                setModalGroupe(false);
                setEditingGroupe(null);
                setFormGroupe({ nom: "" });
                await fetchGroupeComplements();

            } catch (error) {
                console.error(error);
                let message = "Une erreur est survenue.";
                if (error.response) {
                    switch (error.response.status) {
                        case 401:
                            message = "Votre session a expiré.";
                            break;
                        case 404:
                            message = "Le groupe de compléments est introuvable.";
                            break;
                        case 409:
                            message = error.response.data.error;
                            break;
                        case 500:
                            message = "Erreur serveur.";
                            break;
                        default:
                            message = error.response.data.error || "Une erreur est survenue.";
                    }
                }
                MySwal.fire({
                    icon: "error",
                    text: message,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 4000,
                });
            } finally {
                setLoading(false);
            }
        } else {
            // Création avec la nouvelle fonction
            const success = await createComplementGroup(formGroupe.nom.trim());
            if (success) {
                setModalGroupe(false);
                setFormGroupe({ nom: "" });
            }
        }
    };

    const handleSaveComplement = async () => {

        // Vérifier que tous les compléments ont un prix
        const invalidItems = itemsForms.filter(item => 
            item.nom.trim() !== "" && (item.prix === "" || item.prix === null || item.prix === undefined)
        );
        
        if (invalidItems.length > 0) {
            MySwal.fire({
                icon: "warning",
                text: "Veuillez saisir un prix pour tous les compléments.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }

        const complements = itemsForms
            .filter(item => item.nom.trim() !== "")
            .map(item => ({
                nom: item.nom.trim(),
                prix: Number(item.prix),
            }));

        if (complements.length === 0) {
            MySwal.fire({
                icon: "warning",
                text: "Veuillez ajouter au moins un complément.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
            });
            return;
        }

        try {
            setLoading(true);

            const response = await axios.post(
                `${base_api_url}cmplt/complement`,
                {
                    id_complement_group: targetGroupeId,
                    complements,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log("Réponse de l'API pour les compléments :", response.data);

            MySwal.fire({
                icon: "success",
                text: "Les compléments ont été ajoutés avec succès.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
            });

            setModalItems(false);
            setItemsForms([{ nom: "", prix: "" }]);

            await fetchGroupeComplements();

        } catch (error) {
            console.error(error);

            let message = "Une erreur est survenue.";

            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        message = "Votre session a expiré.";
                        break;
                    case 404:
                        message = "Le groupe de compléments est introuvable.";
                        break;
                    case 409:
                        message = error.response.data.error;
                        break;
                    case 500:
                        message = "Erreur serveur.";
                        break;
                    default:
                        message = error.response.data.error || "Une erreur est survenue.";
                }
            }

            MySwal.fire({
                icon: "error",
                text: message,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 4000,
            });

        } finally {
            setLoading(false);
        }
    };

    const handleDeleteGroupe = async (idComplementGroup) => {
        try {
            setLoading(true);

            await axios.put(
                `${base_api_url}cmplt/complement_group/${idComplementGroup}`,
                {
                    statut: 0
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            MySwal.fire({
                icon: "success",
                text: "Le groupe de compléments a été supprimé avec succès.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
            });

            await fetchGroupeComplements();

        } catch (error) {
            console.error(error);

            MySwal.fire({
                icon: "error",
                text: error.response?.data?.error || "Erreur lors de la suppression.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 4000,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGroupeComplements();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    /* ================================================================
       MODAL GROUPE — Créer / Éditer
    ================================================================ */
    const openCreateGroupe = () => {
        setEditingGroupe(null);
        setFormGroupe(Complement_groupe);
        setModalGroupe(true);
    };

    const openEditGroupe = (e, groupe) => {
        e.stopPropagation();
        setEditingGroupe(groupe);
        setFormGroupe({
            nom: groupe.nom,
        });
        setModalGroupe(true);
    };

    /* ================================================================
       MODAL ITEMS — Ajouter plusieurs compléments dans un groupe
    ================================================================ */
    const openAddComplement = (e, groupeId) => {
        e.stopPropagation();
        setTargetGroupeId(groupeId);
        setItemsForms([{ ...COMPLEMENT }]);
        setModalItems(true);
    };

    const addItemRow = () =>
        setItemsForms(prev => [...prev, { ...COMPLEMENT }]);

    const removeItemRow = (idx) =>
        setItemsForms(prev => prev.filter((_, i) => i !== idx));

    const updateItemRow = (idx, field, value) =>
        setItemsForms(prev =>
            prev.map((row, i) => i === idx ? { ...row, [field]: value } : row)
        );

    const askDeleteGroupe = (e, groupe) => {
        e.stopPropagation();
        setDeleteTarget({ type: 'groupe', groupeId: groupe.id_complement_group, nom: groupe.nom });
        setModalDelete(true);
    };

    // const askDeleteItem = (groupeId, complements) => {
    //     setDeleteTarget({ type: 'complements', groupeId, complementId: complements.id_complement, nom: complements.nom });
    //     setModalDelete(true);
    // };

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        if (deleteTarget.type === "groupe") {
            await handleDeleteGroupe(
                deleteTarget.groupeId,
                deleteTarget.nom
            );
        }

        setModalDelete(false);
        setDeleteTarget(null);
    };

    /* ── Utilitaires d'affichage ────────────────────────────── */
    const formatPrix = (prix) => {
        if (!prix || prix === 0) return 'Gratuit';
        return `+${parseFloat(prix).toFixed(2)} ${devise}`;
    };

    return (
        <div className="page-wrapper">
            <SessionControl
                storageKey="user"
                propsup="email"
                redirectTo={route.signin}
            />
            <CheckRestauSelected
                storageKey="user"
            />

            <div className="complements-page">

                {/* ── Navigation catalogue ───────────────────── */}
                <CatalogueNav
                    activeTabId="complèments"
                    subtitle="Gérez vos groupes de compléments et options."
                    addButtonText="Nouveau groupe de compléments"
                    onAddClick={openCreateGroupe}
                />

                {/* ── Barre de recherche ─────────────────────── */}
                <div className="search-bar-comp">
                    <Search size={16} className="search-icon-comp" />
                    <input
                        type="text"
                        placeholder="Rechercher un complément..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                </div>

                {/* ── Section : liste des groupes ────────────── */}
                <p className="section-title">
                    {filteredGroupes.length} groupe{filteredGroupes.length !== 1 ? 's' : ''} de compléments
                </p>
                {loading ? (
                    <div className="loading-container">
                        <p>Chargement des groupes de compléments...</p>
                    </div>
                ) : filteredGroupes.length === 0 ? (
                    <div className="empty-state">
                        <div className="empty-icon-box">
                            <Layers size={28} />
                        </div>
                        <h3>Aucun groupe de compléments</h3>
                        <p>
                            Créez votre premier groupe pour ajouter des options
                            et suppléments à vos articles.
                        </p>
                    </div>
                ) : (
                    <div className="complements-list">
                        {filteredGroupes.map(groupe => {
                            const isOpen = !!openGroups[groupe.id_complement_group];
                            return (
                                <div
                                    key={groupe.id_complement_group}
                                    className={`complement-group-card${isOpen ? ' is-open' : ''}`}
                                >
                                    {/* ── En-tête du groupe ──────────────────── */}
                                    <div
                                        className="group-header-row"
                                        onClick={() => toggleGroup(groupe.id_complement_group)}
                                        role="button"
                                        aria-expanded={isOpen}
                                    >
                                        <div className="group-header-left">
                                            <div className="group-icon-box">
                                                <Layers size={16} />
                                            </div>
                                            <div className="group-info">
                                                <div className="group-name">{groupe.nom}</div>
                                            </div>
                                        </div>

                                        <div className="group-header-right">
                                            <span className="badge-count">
                                                {groupe.complements?.length || 0} complément{groupe.complements?.length !== 1 ? 's' : ''}
                                            </span>
                                            {/* Actions */}
                                            <button
                                                className="btn-group-action"
                                                title="Modifier le groupe"
                                                onClick={e => openEditGroupe(e, groupe)}
                                            >
                                                <Edit2 size={15} />
                                            </button>
                                            <button
                                                className="btn-group-action danger"
                                                title="Supprimer le groupe"
                                                onClick={e => askDeleteGroupe(e, groupe)}
                                            >
                                                <Trash2 size={15} />
                                            </button>

                                            <ChevronDown
                                                size={17}
                                                className={`chevron-icon${isOpen ? ' open' : ''}`}
                                            />
                                        </div>
                                    </div>

                                    {/* ── Contenu accordéon ──────────────────── */}
                                    {isOpen && (
                                        <div className="complement-items-list">
                                            {(groupe.complements?.length || 0) === 0 ? (
                                                <div className="group-empty-items">
                                                    Aucun complément dans ce groupe.
                                                </div>
                                            ) : (
                                                (groupe.complements || []).map(complements => (
                                                    <div key={complements.id_complement} className="complement-item-row">
                                                        <div className="item-left">
                                                            <span className="item-dot" />
                                                            <div className="item-info">
                                                                <div className="item-name">{complements.nom}</div>
                                                            </div>
                                                        </div>
                                                        <div className="item-right">
                                                            <span className={`item-price${!complements.prix ? ' free' : ''}`}>
                                                                {formatPrix(complements.prix)}
                                                            </span>
                                                            {/* 
                                                            <button
                                                                className="btn-group-action danger"
                                                                title="Supprimer ce complément"
                                                                onClick={() => askDeleteItem(groupe.id_complement_group, complements)}
                                                            >
                                                                <Trash2 size={14} />
                                                            </button>
                                                            */}
                                                        </div>
                                                    </div>
                                                ))
                                            )}

                                            {/* Bouton ajouter dans le groupe */}
                                            <button
                                                className="btn-add-in-group"
                                                onClick={e => openAddComplement(e, groupe.id_complement_group)}
                                            >
                                                <Plus size={14} />
                                                Ajouter des compléments
                                            </button>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* ================================================================
                MODAL — Créer / Éditer un groupe
            ================================================================ */}
            {modalGroupe && (
                <div className="modal-overlay-custom">
                    <div className="modal-box-custom">

                        <div className="modal-hdr">
                            <div className="modal-hdr-left">
                                <h2>{editingGroupe ? 'Modifier le groupe' : 'Nouveau groupe de compléments'}</h2>
                            </div>
                            <button className="btn-close-modal" onClick={() => setModalGroupe(false)}>
                                <X size={16} />
                            </button>
                        </div>

                        <div className="modal-bdy">
                            {/* Nom */}
                            <div className="fld">
                                <label className="fld-label">
                                    Nom du groupe <span className="req">*</span>
                                </label>
                                <input
                                    className="fld-input"
                                    placeholder="Ex : Sauces, Cuisson, Suppléments…"
                                    value={formGroupe.nom}
                                    onChange={e => setFormGroupe(p => ({ ...p, nom: e.target.value }))}
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div className="modal-ftr">
                            <button className="btn-cancel-c" onClick={() => setModalGroupe(false)}>
                                Annuler
                            </button>
                            <button
                                className="btn-primary-c"
                                onClick={handleSaveGroupe}
                                disabled={!formGroupe.nom.trim()}
                            >
                                <Layers size={15} />
                                {editingGroupe ? 'Enregistrer' : 'Créer le groupe'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ================================================================
                MODAL — Ajouter plusieurs compléments dans un groupe
            ================================================================ */}
            {modalItems && (
                <div className="modal-overlay-custom">
                    <div className="modal-box-custom lg">

                        <div className="modal-hdr">
                            <div className="modal-hdr-left">
                                <h2>Ajouter des compléments</h2>
                                <p>
                                    Groupe&nbsp;:&nbsp;<strong>
                                        {groupes.find(g => g.id_complement_group === targetGroupeId)?.nom}
                                    </strong>
                                </p>
                            </div>
                            <button className="btn-close-modal" onClick={() => setModalItems(false)}>
                                <X size={16} />
                            </button>
                        </div>

                        <div className="modal-bdy">
                           
                            {/* Labels */}
                            <div className="items-header-labels">
                                <span>Nom du complément</span>
                                <span>Prix (+{devise})<span style={{ color: '#ef4444' }}>*</span></span>
                                <span></span>
                            </div>

                            {/* Lignes */}
                            <div className="items-form-list">
                                {itemsForms.map((row, idx) => (
                                    <div key={idx} className="item-form-row">
                                        <input
                                            className="fld-input"
                                            placeholder="Ex : Sauce ketchup"
                                            value={row.nom}
                                            onChange={e => updateItemRow(idx, 'nom', e.target.value)}
                                            autoFocus={idx === 0}
                                        />
                                        <input
                                            className="fld-input"
                                            type="number"
                                            min={0}
                                            step={0.1}
                                            placeholder="0.00"
                                            value={row.prix}
                                            onChange={e => updateItemRow(idx, 'prix', e.target.value)}
                                            required
                                        />
                                        <button
                                            className="btn-rm-item"
                                            onClick={() => removeItemRow(idx)}
                                            disabled={itemsForms.length === 1}
                                            title="Supprimer cette ligne"
                                        >
                                            <X size={14} />
                                        </button>
                                    </div>
                                ))}
                            </div>

                            {/* Ajouter une ligne */}
                            <button className="btn-add-item-row" onClick={addItemRow}>
                                <Plus size={14} />
                                Ajouter une ligne
                            </button>
                        </div>

                        <div className="modal-ftr">
                            <button className="btn-cancel-c" onClick={() => setModalItems(false)}>
                                Annuler
                            </button>
                            <button
                                className="btn-primary-c"
                                onClick={handleSaveComplement}
                                disabled={!itemsForms.some(r => r.nom.trim())}
                            >
                                <Plus size={15} />
                                Ajouter {itemsForms.filter(r => r.nom.trim()).length || ''} complément
                                {itemsForms.filter(r => r.nom.trim()).length > 1 ? 's' : ''}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ================================================================
                MODAL — Confirmation de suppression
            ================================================================ */}
            {modalDelete && deleteTarget && (
                <div className="modal-overlay-custom">
                    <div className="modal-box-custom" style={{ maxWidth: 420 }}>

                        <div className="modal-bdy" style={{ paddingTop: 28, paddingBottom: 8 }}>
                            <div className="confirm-icon-box">
                                <AlertTriangle size={26} />
                            </div>
                            <p className="confirm-title">
                                {deleteTarget.type === 'groupe'
                                    ? 'Supprimer ce groupe ?'
                                    : 'Supprimer ce complément ?'
                                }
                            </p>
                            <p className="confirm-text">
                                Vous allez supprimer&nbsp;
                                <span className="confirm-name">« {deleteTarget.nom} »</span>.
                                {deleteTarget.type === 'groupe' && (
                                    <> Tous les compléments de ce groupe seront également supprimés.</>
                                )}
                                <br />Cette action est irréversible.
                            </p>
                        </div>

                        <div className="modal-ftr">
                            <button
                                className="btn-cancel-c"
                                onClick={() => { setModalDelete(false); setDeleteTarget(null); }}
                            >
                                Annuler
                            </button>
                            <button className="btn-delete-c" onClick={confirmDelete}>
                                <Trash2 size={15} />
                                Supprimer
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Complements;